import Typography from '@mui/material/Typography';
import UndoIcon from '@mui/icons-material/Undo';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import appMessages from '~/containers/App/messages';
import { useRevokeShiftApplication } from '~/hooks/api/useRevokeShiftApplication';
import messages from './messages';
import styles from './styles.module.css';

type RevokeShiftApplicationButtonProps = {
  shiftId: number;
  turnId?: number;
  applicationId: number;
};

const RevokeShiftApplicationButton = (
  props: RevokeShiftApplicationButtonProps
) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();

  const revokeShiftApplicationMutation = useRevokeShiftApplication({
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.revokeShiftApplicationFailure),
      });
    },
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.revokeShiftApplicationSuccess),
      });
    },
  });
  return revokeShiftApplicationMutation.isPending ? (
    <div className={styles.button}>
      <Typography variant="body2">
        <FormattedMessage {...appMessages.loading} />
      </Typography>
    </div>
  ) : (
    <button
      type="button"
      className={styles.button}
      onClick={() => {
        revokeShiftApplicationMutation.mutate({
          turnId: props.turnId,
          shiftId: props.shiftId,
          shiftApplicationId: props.applicationId,
        });
      }}
    >
      <Typography variant="body2">
        <UndoIcon
          sx={{ fontSize: 16, verticalAlign: 'text-bottom', mr: 0.5 }}
        />
        <FormattedMessage {...messages.revokeShiftApplication} />
      </Typography>
    </button>
  );
};

export default RevokeShiftApplicationButton;
